define.alias("shared/components/shared/pre-boarding/index", "calendar/components/shared/pre-boarding/index");